import { PodcastListType } from '@nimey/podcast-global-entity';
import { ListLayout, PodcastList } from './podcast';


export const AboPodcasts = (props: { limit?: number }) => {
  return <PodcastList layout={ListLayout.CAROUSEL} listType={PodcastListType.USER_ABO} {...props} title='podcast.list.recent-abo.title' />
}